export default {
  switcher: [
    {
      title: 'Français',
      lang: 'fr'
    },
    {
      title: 'English',
      lang: 'en'
    },
    {
      title: '日本語',
      lang: 'jp'
    },
    {
      title: '简体中文',
      lang: 'cn'
    },
    {
      title: '한국어',
      lang: 'kr'
    }
  ],
  currentLanguage: {
    title: '繁體中文',
    lang: 'cht'
  },
  nextPage: '下一頁',
  previousPage: '上一頁',
  backWorld: '返回「CHAUMET世界」'
}



// WEBPACK FOOTER //
// ./src/locales/cht/main.js